import { connect } from 'react-redux'
import { makeSelectIsBootstrapTypesLoaded } from 'selectors/bootstrap/makeSelectIsBootstrapTypesLoaded'
import { selectFolderCollections } from 'ducks/folders/selectors/collections'
import { doBuildMenuFromWidgets } from 'ducks/folders/operations/collections'
import { subscribeSyncSearches } from 'ducks/searches/operations/subscribeSyncSearches'
import { subscribeChatBotState } from 'ducks/chat/operations/subscribeChatBotState'
import { selectIsMatrixClientReady } from 'ducks/chat/selectors/client'
import FoldersView from './view'

const selectIsBootstrapTypesLoaded = makeSelectIsBootstrapTypesLoaded([
  'folders',
  'widgets',
  'currentUser',
])

const select = state => {
  return {
    collections: selectFolderCollections(state),
    isBootstrapped: selectIsBootstrapTypesLoaded(state),
    isMatrixClientReady: selectIsMatrixClientReady(state),
  }
}

const perform = dispatch => ({
  onBootstrap: client => {
    dispatch(doBuildMenuFromWidgets())
    dispatch(subscribeSyncSearches(client))
    dispatch(subscribeChatBotState(client))
  },
})

export default connect(select, perform)(FoldersView)
